import styled from "styled-components";

const ThanksContainer = styled.section`
  .inquiry-thankyou {
    padding: 150px 20px 30px;
    min-height: 100vh;
    margin-bottom: 0;
    background: #fff;
    h1 {
      color: #000;
      font-size: 36px;
      font-weight: 400;
    }
    p {
      a {
        color: ${(props) => props.theme.colors.primary.main}
        text-decoration: underline;
        transition: all 0.6s ease 0s;
        &:hover {
          color: #e0331a;
        }
      }
    }
  }
  a.cart-thanks {
    background: #1EBEC8;
    color: #fff;
    padding: 15px 30px;
    transition: all 0.6s ease 0s;
    text-transform: uppercase;
    &:hover {
      background: #2f2f2f;
    }
  }
  .additional-videos {
    h2 {
      color: #000;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 2px;
      font-size: 20px;
    }
    a {
      h4 {
        color: #000;
        font-size: 16px;
        text-align: left;
        margin-top: 10px;
        font-weight: 400;
      }
    }
  }
  .align-center {
    text-align: center;
  }
  .search-result {
    margin: 0;
    padding: 0 30px 50px;
  }
  .searchItem {
    display: flex;
    display: -ms-flexbox;
    display: -webkit-flex;
    flex-direction: row;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
  .result-item {
    margin: 20px 25px 15px;
    max-width: 260px;
    min-width: 260px;
    img {
      margin: auto;
      height: 100%;
      display: block;
      max-width: 260px;
      background: #000;
      border: 0;
      max-height: 148px;
    }
    a {
      &:hover {
        h3 {
          color: ${(props) => props.theme.colors.primary.main}
          transition: all 0.6s ease 0s;
        }
        p {
          color: ${(props) => props.theme.colors.primary.main}
          transition: all 0.6s ease 0s;
          span {
            color: ${(props) => props.theme.colors.primary.main}
            transition: all 0.6s ease 0s;
          }
        }
      }
    }
    .itemTitle {
      padding-top: 0;
      background: #fff;
      p {
        padding-top: 15px;
      }
    }
  }
  i {
    font-style: normal;
  }
  .iar {
    height: 5px;
    background: #f04f37;
    width: 100%;
  }
  #video-box-template {
    text-align: left;
  }
`;

export default ThanksContainer;
